import { IShare1IconProps } from "interfaces";

const Share1Icon = ({ className, onClick }: IShare1IconProps) => {
    return (
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path d="M12.4128 0L11.6055 0.408716V2.96193C8.92677 2.86605 6.30928 3.77696 4.26881 5.51514C1.43303 8.0078 0 12.0697 0 17.6252L0.973853 17.8069C1.07477 17.5596 3.41101 11.8073 11.6055 11.5803V14.6633L12.4128 15.067L22 7.9422V7.12982L12.4128 0ZM12.6147 13.6592V11.0656L12.1101 10.561C5.85321 10.561 2.56835 13.6339 1.07477 15.6725C1.36743 11.4239 2.65917 8.27018 4.91972 6.27706C6.71008 4.76809 8.98158 3.95006 11.3229 3.9711C11.767 3.9711 12.0344 4.00138 12.0445 4.00138L12.6147 3.49679V1.41284L20.8495 7.53349L12.6147 13.6592Z" />
        </svg>
    )
}

export default Share1Icon;